module.exports = __webpack_public_path__ + "51d0f8898d1f7a7e6f836e25fe4fa694.fbx";